package one.healthium.log_period.ui.utils

import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update
import kotlinx.datetime.LocalDate
import one.healthium.base.utils.InstantToLocalDate
import one.healthium.base.utils.LocalDateToInstant
import one.healthium.log_period.domain.PeriodTrackerInteractor
import one.healthium.ui.common.event_producer.EventProducer
import one.healthium.ui.common.vm.BaseViewModel

internal class PeriodCalendarViewModel(
    private val periodInteractor: PeriodTrackerInteractor,
) : BaseViewModel() {

    private val _state = MutableStateFlow(LogPeriodUiState(emptyList()))
    val state = _state.asStateFlow()
    val events = EventProducer<LogPeriodEvents>()

    init {
        launch {
            periodInteractor.observePeriodLog().collect {
                _state.update { state ->
                    state.copy(periodDays = it.periods.map { InstantToLocalDate(it) })
                }
            }
        }
    }

    fun onCalendarClick(day: LocalDate) {
        val days = _state.value.periodDays.toMutableList()
        if (days.contains(day)) {
            days.remove(day)
        } else {
            days.add(day)
        }
        _state.update { state ->
            state.copy(periodDays = days)
        }
    }

    fun onPeriodsSaveClicked() {
        launch {
            periodInteractor.setPeriods(_state.value.periodDays.map { LocalDateToInstant(it) })
            events.trigger(LogPeriodEvents.PeriodUpdated)
        }
    }
}